import { render, staticRenderFns } from "./importBranch.vue?vue&type=template&id=55b8e432&scoped=true&"
import script from "./importBranch.vue?vue&type=script&lang=ts&"
export * from "./importBranch.vue?vue&type=script&lang=ts&"
import style0 from "./importBranch.vue?vue&type=style&index=0&id=55b8e432&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55b8e432",
  null
  
)

export default component.exports